<template>
    <div
        class="h-[164px] w-full xl:w-[580px] m-auto rounded-xl bg-[#4D4DBD66] flex justify-center items-center flex-col cursor-pointer relative"
        :class="state === 'error' ? 'border border-red-200 bg-red-400 bg-opacity-10' : 'bg-brand-transparent-40'"
        @click="selectInput"
        @dragover.prevent.stop="onDragOver"
        @dragleave.prevent.stop="onDragLeave"
        @drop.prevent="onDrop"
    >
        <input
            type="file"
            :id="id"
            ref="inputRef"
            @change="(event) => $emit('onChange', (event.target as HTMLInputElement).files)"
            class="hidden"
        />
        <slot />
    </div>
</template>

<script setup lang="ts">
interface IProps {
    state: "error" | "default" | "inprogress";
    id: string;
}

const props = withDefaults(defineProps<IProps>(), {
    state: "default",
});

const emits = defineEmits(["onDrop", "onChange"]);

const isDragging = ref(false);

const inputRef = ref<null | HTMLInputElement>(null);
const selectInput = () => {
    if (props.state !== "default") return;
    inputRef.value?.click();
};

const onDragOver = () => {
    isDragging.value = true;
};

const onDragLeave = () => {
    isDragging.value = false;
};
const onDrop = (event: DragEvent) => {
    event.preventDefault();
    if (props.state !== "default") return;
    isDragging.value = false;
    emits("onDrop", event.dataTransfer?.files);
};
</script>
